module.exports = __webpack_public_path__ + "static/media/badge.0c99dd2b.svg";